import { PreCadastroType } from '../../types/PreCadastro.types';
import * as httpHelper from '../../utils/http-helper';

function buscarDadosIniciais() {
  const headers = httpHelper.defaultHeaders();
  
  return httpHelper.get(
    headers,
    'PreCadastro/DadosIniciais'
  );
}

function buscarCidades(uf: string) {
  const headers = httpHelper.defaultHeaders();
  
  return httpHelper.get(
    headers,
    `PreCadastro/Cidades?_idUF=${uf}`
  );
}

function buscarDatasAtendimento() {
  const headers = httpHelper.defaultHeaders();
  
  return httpHelper.get(
    headers,
    'PreCadastro/GetListaDataAtendimento'
  );
}

function buscarHorariosAtendimento(data: string) {
  const headers = httpHelper.defaultHeaders();
  
  return httpHelper.get(
    headers,
    `PreCadastro/GetListaHorarioAtendimento?_data=${data}`
  );
}

function buscarAgendamentoAtual(cpf: string, dtNascimento: string) {
  const headers = httpHelper.defaultHeaders();
  
  return httpHelper.get(
    headers,
    `PreCadastro/GetAgendamentoAtual?_cpf=${cpf}&_dtNascimento=${dtNascimento}`
  );
}

function verificaCadastro(cpf: string) {
  const headers = httpHelper.defaultHeaders();
  
  return httpHelper.get(
    headers,
    `PreCadastro/GetIDProponente?_cpf=${cpf}`
  );
}

function realizarPreCadastro(form: PreCadastroType) {
  const headers = httpHelper.defaultHeaders();
  
  return httpHelper.post(
    headers,
    {
      ...form,
      regimeComunhaoID: form.regimeComunhaoID === 0 ? null : form.regimeComunhaoID,
      tipoSanguineoID: form.tipoSanguineoID === 0 ? null : form.tipoSanguineoID,
      especialidadeID: form.especialidadeID === 0 ? null : form.especialidadeID,
    },
    'PreCadastro/Post'
  );
}

function reagendarPreCadastro(form: PreCadastroType) {
  const headers = httpHelper.defaultHeaders();
  
  return httpHelper.post(
    headers,
    {
      ...form,
      regimeComunhaoID: form.regimeComunhaoID === 0 ? null : form.regimeComunhaoID,
      tipoSanguineoID: form.tipoSanguineoID === 0 ? null : form.tipoSanguineoID,
      especialidadeID: form.especialidadeID === 0 ? null : form.especialidadeID,
    },
    'PreCadastro/Reagendamento'
  );
}

const recuperarSenhaService = {
  buscarDadosIniciais,
  buscarCidades,
  buscarDatasAtendimento,
  buscarHorariosAtendimento,
  verificaCadastro,
  buscarAgendamentoAtual,
  realizarPreCadastro,
  reagendarPreCadastro,
}

export default recuperarSenhaService;
